import gql from 'graphql-tag'

export const category = gql`
	fragment categorymain on Category {
		name
		color
		description
		position
		dimensions
		validAfter
		isActive
		isForMobileWaiter
		isLearningMode
		pluMode
		weekDays
		tagId
		sortId
		shopId
		gridProducts {
			id
			# mod_ver
			position
			productId
			categoryId
			product {
				id
				name
				code
				price
				img {
					uid
					key
				}
				category {
					id
		    	color
		    }
			}
		}
	}
`

export const surcharge = gql`
	fragment categorySurcharge on Category {
		surchargePercent
    surchargeAmount
    surchargeFrom
	}
`

export const options = gql`
	fragment categoryOptions on Category {
		isNoAction
		categoryId
		priceLevel
		isActiveInHouse
		img {
			uid
			key
		}
	}
`

export const listCategories = gql`
	fragment listCategories on CategoryConnection {
		items {
			id
			mod_ver
			name
			position
			color
            isActive
		}
		cursors {
			hasNext
			hasPrevious
			before
			after
		}
        total
		hasNextPage
	}
`

export const CCItem = gql`
	fragment CCItem on CCRoute {
		id
		categoryImgs(categoryId: $categoryId) {
			id
			imgUrl
		}
	}
`
